import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { SessionService } from '../../services/session2.service';
import { AdminService } from '../../services/admin.service';
import { ErrorService } from '../../services/error.service';
import { NerService } from '../../services/ner.service';
import { GlobalMessageService } from '../../services/global-message.service';

import { Constants, EntityType } from '../../global/constants';

import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-admin-ner',
  templateUrl: './admin-ner.component.html'
})
export class AdminNerComponent implements OnInit {

  loadingPage = true;
  session: any;

  showTest:boolean = false;
  currentType:string = 'city';
  currentTerms: any[] = [];

  searchText: string = '';

  testContent: string = '';
  testResults: any = {};

  constructor(private cacheService: CacheService,
              private sessionService: SessionService,
              private errorService: ErrorService,
              private modalService: BsModalService,
              private nerService: NerService,
              private constants: Constants,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    this.session = this.cacheService.get('session');
    if (!this.session) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.session = session;
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  search() {
    this.session.ner_filters[this.currentType].term = this.searchText;
    this.saveSession();
    this.refreshTraining();
  }

  changeType(type: EntityType) {
    this.currentType = type.name;
    this.searchText = '';
    this.resetFilters();
    this.refreshTraining();
  }

  setSort(field: string) {
    let cDirection = 1;
    if (field == this.session.ner_filters[this.currentType].sort.field) {
      cDirection = this.session.ner_filters[this.currentType].sort.direction * (-1);
    }
    this.session.ner_filters[this.currentType].sort = {
      field: field,
      direction: cDirection
    };
    this.saveSession();
    this.refreshTraining();
  }

  delete(term: any) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Confirm you'd like to delete this term: "${term.term}"`,
        confirm: function() {
          this.nerService.deleteTerm(this.currentType, term._id).subscribe(
            (result: any) => {
              this.globalMessageService.message('Term was deleted');
              this.refreshTraining();
            },
            error => {
              this.globalMessageService.error();
              this.errorService.log(error, 'admin-ner.component', 'delete');
            });
        }
      }
    }));
  }

  test() {
    // need this to notify the output component to refresh
    this.testResults = {};
    this.nerService.extract('na').subscribe(
      (result: any) => {
        this.testResults = JSON.parse(result);
      },
      error => {
          this.globalMessageService.error();
          this.errorService.log(error, 'admin-ner.component', 'test');
      }
    )
  }

  clear() {
    this.testContent = '';
    this.testResults = {};
  }

  private initView() {
    if (!this.session.ner_filters || this.session.ner_filters.length == 0) {
      this.resetFilters();
    }

    var now = new Date();
    var lastUpdate = new Date(this.session.ner_filters.last_changed);
    if (now.getTime() - lastUpdate.getTime() > 900000) {
      // 900000ms = 15 minutes. Let's reset filters if it's been more than 15 minutes since they were last last changed
      this.resetFilters();
    }

    this.refreshTraining();
  }

  private refreshTraining() {
    this.loadingPage = true;
    this.currentTerms = [];
    this.nerService.getTerms(this.currentType, this.session.ner_filters[this.currentType]).subscribe(
      (result: any) => {
        this.currentTerms = result;
        this.loadingPage = false;
      },
      error => {

      }
    )
  }

  private saveSession() {
    this.session.ner_filters.last_changed = new Date();
    this.sessionService.saveSession(this.session).subscribe(
      (result: any) => {
        // Nothing
      },
      err => {
        this.errorService.log(err, 'admin-ner.component', 'saveSession');
      }
    )
  }

  private resetFilters() {
    if (!this.session.ner_filters) {
      this.session.ner_filters = [];
    }

    if (!this.session.ner_filters[this.currentType]) {
      this.session.ner_filters[this.currentType] = {
        term: '',
        status: '*',
        source: '*',
        length: null,
        page: 1,
        sort: {
          field: 'term',
          direction: 1
        }
      };
    }
    this.saveSession();
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-ner/admin-ner.component.ts